import { render, staticRenderFns } from "./SelectorDireccion.vue?vue&type=template&id=04fc3dd2"
import script from "./SelectorDireccion.vue?vue&type=script&lang=js"
export * from "./SelectorDireccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04fc3dd2')) {
      api.createRecord('04fc3dd2', component.options)
    } else {
      api.reload('04fc3dd2', component.options)
    }
    module.hot.accept("./SelectorDireccion.vue?vue&type=template&id=04fc3dd2", function () {
      api.rerender('04fc3dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Direccion/SelectorDireccion.vue"
export default component.exports